import { useMemo } from 'react';
import { Timestamp } from '@framework/Timestamp';
import { useGroupLicensePermissions } from './useGroupLicensePermissions';

/**
 * ビューモデルのcreatedAtが30日より前かどうかを判定する（内部関数）
 * 時刻を無視して日付単位で比較する
 */
const isViewModelOlderThan30Days = (createdAt: Timestamp): boolean => {
  const thirtyDaysAgo = Timestamp.now().addDays(-30).startOf('day');
  const createdAtDay = createdAt.startOf('day');
  return createdAtDay.isBefore(thirtyDaysAgo);
};

/**
 * グループライセンスによるビューモデルアクセス制限を判定する
 * @param createdAt ビューモデルの作成日時
 * @returns 制限されている場合は true
 */
export const useIsViewModelRestrictedByGroupLicensePermission = (createdAt: Timestamp): boolean => {
  const groupLicensePermissions = useGroupLicensePermissions();

  return useMemo(
    () => !groupLicensePermissions?.unlimitedViewModelAccess && isViewModelOlderThan30Days(createdAt),
    [groupLicensePermissions?.unlimitedViewModelAccess, createdAt]
  );
};
